import React from 'react';
import { Page } from 'components/shared/Page/Page';
import { TrailUgcProvider } from 'components/trailUgc/TrailUgcContext';
import { Context } from '@alltrails/shared/types/context';
import Review from 'types/Review';
import ReviewsUgc, { ReviewsUgcProps } from '../ReviewsUgc';

/**
 * A simple component to wrap ReviewsUgc in required providers to independently function.
 * Used for SSR.
 */
const ReviewsUgcWrapper = (props: ReviewsUgcProps & { context: Context; items: { trail_reviews: Review[] }; maxItems: number }): JSX.Element => {
  const { context, items, maxItems, ...remainingProps } = props;
  return (
    <Page context={context}>
      <TrailUgcProvider ugcInfo={{ reviews: items.trail_reviews, itemTotals: { reviews: maxItems } }}>
        <ReviewsUgc {...remainingProps} />
      </TrailUgcProvider>
    </Page>
  );
};

export default ReviewsUgcWrapper;
